<template>
    <div class="content">
        <Banner></Banner>
        <Service></Service>
        
        <Create></Create>
        <Bottom :data="attr"></Bottom>
        <Solution></Solution>
        
        <Footer></Footer>
    </div>
</template>
<script>
import { onMounted,ref,reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
import Banner from '@/components/Banner.vue'
import Create from '@/components/Create.vue'
import Service from '@/components/Service.vue'
import Solution from '@/components/Solution.vue'
import Bottom from '@/components/Bottom.vue'
import Footer from '@/components/Footer.vue'
export default {
    components:{
        Banner,
        Create,
        Service,
        Solution,
        Bottom,
        Footer
    },
    setup(){
		let host = ref("cungao.top");
        const store = useStore()
        let state = reactive({
            attr:{}
        });
        onMounted(()=>{
            if (process.env.NODE_ENV !== "development") {
                host.value = window.location.host.replace("www.", "");
            }
            // getData()
        })
        const getData = ()=>{
            // 异步请求
            axios({
				// url:`https://www.cungao.top/account.json`,
				url: '',
                method:'get'
            }).then(response=>{
                const res = response.data;
                let data = {
                    companyName:res.data.list[0].company,
                    record_num:res.data.list[0].icp
                }
                state.attr = JSON.parse(res.data.list[0].attr)
                document.getElementsByTagName('title')[0].text = res.data.list[0].company;
                store.commit("setCompany", data)
            })
        }
        return{
            ...toRefs(state)
        }
    }
}
</script>
<style scoped lang="scss">
    .content{
        width: 100%;
    }
</style>